<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block"></div>

            <Header></Header>

            <section class="content create-due-content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-11 form-request-content-large">
                            <div class="request-title">
                                <h1>DUE : Créer</h1>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                          <ul class="breadcrumb-steps">
                            <li class="breadcrumb-steps__item success">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Création du modèle de DUE
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item active">
                              <span class="breadcrumb-steps__num">2</span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des bénéficiaires
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item">
                              <span class="breadcrumb-steps__num">3</span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des cotisations
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">4</span>
                              <span class="breadcrumb-steps__descr">
                                Délais applicables
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">5</span>
                              <span class="breadcrumb-steps__descr">
                                Cas de dispense facultatifs
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">6</span>
                              <span class="breadcrumb-steps__descr">
                                Documents annexes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">7</span>
                              <span class="breadcrumb-steps__descr">
                                Informations importantes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">8</span>
                              <span class="breadcrumb-steps__descr">
                                Signature éléctronique
                              </span>
                            </li>
                          </ul>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                            <div class="required-field-text">Champs obligatoires</div>
                            <div class="form-group">
                                <form name="exemption"
                                      method="post"
                                      enctype="multipart/form-data"
                                      novalidate="novalidate"
                                      class="needs-validation"
                                >
                                    <!-- Bénéficiaires -->
                                    <div class="form-group">
                                        <label class="required-field-asterisks"
                                               for="beneficiaries">Salariés bénéficiaires
                                        </label>
                                        <select id="beneficiaries"
                                                class="form-control select2"
                                                v-model="formData.beneficiary"
                                                :class="{ 'is-invalid': this.error }"
                                        >
                                            <option v-for="beneficiary in filteredBeneficiaries"
                                                    :key="beneficiary.id"
                                                    :value="beneficiary"
                                            >{{ beneficiary.shortTitle }}</option>
                                        </select>
                                        <p v-if="legalInformation"
                                           class="input-legend"
                                        >{{ legalInformation.beneficiary.legalAdvice }}</p>
                                        <FormError :error="this.error"
                                                   v-if="this.error"
                                        ></FormError>
                                    </div>
                                    <!-- Bénéficiaires -->
                                </form>
                            </div>
                        </div>

                        <div class="input-group col-md-10 mx-sm-auto my-md-4">
                            <div class="mx-sm-auto">
                                <button class="btn btn-lg btn-link btn__primary"
                                        :disabled="saveIsLoading || nextStepIsLoading"
                                        @click.prevent="toPreviousStep"
                                >
                                    <span>Revenir à l'étape précédente</span>
                                </button>

                                <button class="btn btn-success btn-lg ml-4 btn-link btn__save"
                                        :disabled="$v.$invalid || saveIsLoading || nextStepIsLoading"
                                        @click.prevent="saveDueSecondStep()"
                                >
                                    <span>Enregistrer le brouillon</span>
                                    <ButtonSpinner :isLoading="saveIsLoading"></ButtonSpinner>
                                </button>
                            </div>
                        </div>

                        <div class="input-group mx-sm-auto">
                            <div class="large-btn__box">
                                <button class="btn btn-success btn-lg btn-link btn__save--large"
                                        :disabled="$v.$invalid || saveIsLoading || nextStepIsLoading"
                                        @click.prevent="saveAndMoveToNextStep()"
                                >
                                    <span>Enregistrer les modifications</span>
                                    <ButtonSpinner :isLoading="nextStepIsLoading"></ButtonSpinner>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../../components/Sidebar';
    import Footer from '../../../components/Footer';
    import ButtonSpinner from '../../../components/ButtonSpinner';
    import DueSecondStepManager from '../../../service/manager/due/secondStepManager';
    import DueStepsNavigation from '../../../mixins/dueStepsNavigation';
    import Header from '../../../components/Header';
    import FormError from '../../../components/FormError';
    import { required } from 'vuelidate/lib/validators';
    import { mapGetters, mapActions } from 'vuex';
    import { fetchBeneficiariesByCollectiveAgreementId } from '../../../service/api/dues.api';
    import HttpStatus from '../../../utils/httpStatusCodes';

    export default {
        mixins: [DueStepsNavigation],
        data() {
            return {
                formData: {
                    beneficiary: null
                },
                beneficiaries: [],
                saveIsLoading: false,
                nextStepIsLoading: false,
                error: null
            };
        },
        computed: {
            ...mapGetters({
                currentStep: 'currentStep',
                due: 'due',
                legalInformation: 'legalInformation'
            }),
            // requires a contact of ORID with the customers, removed for now
            filteredBeneficiaries() {
                return this.beneficiaries.filter(beneficiary => beneficiary.code !== 'b4');
            }
        },
        async created() {
            await this.fetchDue();
            await this.fetchDueLegalInformation();
            await this.fetchBeneficiaries();
            await this.setCurrentStep(2);
        },
        methods: {
            ...mapActions({
                setCurrentStep: 'setCurrentStep',
                setActiveDue: 'setActiveDue',
                fetchCurrentDue: 'fetchCurrentDue',
                updateCurrentDue: 'updateCurrentDue',
                fetchDueLegalInformation: 'fetchDueLegalInformation'
            }),
            async fetchDue() {
                await this.fetchCurrentDue(this.$route.params.id);
                this.formData = {
                    ...this.formData,
                    ...DueSecondStepManager.createFormDataForSecondStepFromResponse(this.due)
                };
            },
            async fetchBeneficiaries() {
                const { data } = await fetchBeneficiariesByCollectiveAgreementId(
                    this.due.collectiveAgreement.id
                );
                this.beneficiaries = data;
            },
            async toPreviousStep() {
                await this.setCurrentStep(null);
                await this.$router.push(this.buildRoute('due-first-step'));
            },
            async updateDue() {
                try {
                    await this.updateCurrentDue({
                        beneficiaryId: this.formData.beneficiary.id
                    });
                } catch ({ response }) {
                    const { data, status } = response;

                    if (HttpStatus.HTTP_BAD_REQUEST === status) {
                        this.error = data.detail;
                    }

                    this.nextStepIsLoading = false;
                    this.saveIsLoading = false;
                }
            },
            async saveDueSecondStep() {
                if (this.isBeneficiaryParticularCase()) {
                    await this.$router.push({ name: 'due-beneficiary-contact-lawyers'});
                    return;
                }
                await this.saveDue();
            },
            async saveAndMoveToNextStep() {
                if (this.isBeneficiaryParticularCase()) {
                    await this.$router.push({ name: 'due-beneficiary-contact-lawyers'});
                    return;
                }
                await this.saveAndMoveForward('due-third-step');
            },
            isBeneficiaryParticularCase() {
                return this.formData.beneficiary.code === 'b4';
            },
            async saveAndMoveForward(nextPageRouteName) {
                this.nextStepIsLoading = true;
                await this.updateDue();

                if (this.nextStepIsLoading) {
                    await this.$router.push(this.buildRoute(nextPageRouteName));
                }

                this.nextStepIsLoading = false;
            },
        },
        watch: {
            formData: {
                handler: function() {
                    if (this.error) {
                        this.error = null;
                    }
                },
                deep: true
            }
        },
        validations: {
            formData: {
                beneficiary: {
                    required
                }
            }
        },
        components: {
            Header,
            Sidebar,
            Footer,
            ButtonSpinner,
            FormError
        }
    }
</script>
